import styled from 'styled-components'

export const CustomHistopathologyContainer = styled.div`
  margin-top: 2rem;
  font-size: 16px;
  line-height: 22px;
  color: var(--grey2);
  list-style-position: inside;

  @media (min-width: 650px) {
    column-count: 2;
    column-gap: 2rem;
  }
`
